/* src/app/private/components/temp-student-profile/student-temp-profile/student-temp-profile.component.scss */
/*# sourceMappingURL=student-temp-profile.component.css.map */
